export enum PaymentState {
    UNPAID = 'UNPAID',
    PAID_CASH = 'PAID_CASH',
    PAID_CARD = 'PAID_CARD',
    PAID_BANCOMAT = 'PAID_BANCOMAT',
    PAID_BANK = 'PAID_BANK'
}